// api.js — versión fetch (equivalente exacta a axios)

export const BASE_URL = "https://quarkia.com.co";
//export const BASE_URL = "http://localhost:7054";
/**
 * ==========================
 * Helpers internos
 * ==========================
 */
const buildHeaders = (useAuth = true) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (useAuth) {
    const token = localStorage.getItem("token");
    if (token) headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

/**
 * ==========================
 * API (con token)
 * ==========================
 */
const API = {
  get: async (url, config = {}) => {
    const fullUrl = new URL(url, BASE_URL);

    if (config.params) {
      Object.entries(config.params).forEach(([key, value]) => {
        fullUrl.searchParams.append(
          key,
          typeof value === "string" ? value : JSON.stringify(value)
        );
      });
    }

    const res = await fetch(fullUrl.toString(), {
      method: "GET",
      headers: buildHeaders(true),
    });

    const data = await res.json();
    if (!res.ok) throw data;
    return { data };
  },

  post: async (url, body = {}) => {
    const res = await fetch(`${BASE_URL}${url}`, {
      method: "POST",
      headers: buildHeaders(true),
      body: JSON.stringify(body),
    });

    const data = await res.json();
    if (!res.ok) throw data;
    return { data };
  },
};

/**
 * ==========================
 * OPEN_API (sin token)
 * ==========================
 */
export const OPEN_API = {
  get: async (url, config = {}) => {
    const fullUrl = new URL(url, BASE_URL);

    if (config.params) {
      Object.entries(config.params).forEach(([key, value]) => {
        fullUrl.searchParams.append(
          key,
          typeof value === "string" ? value : JSON.stringify(value)
        );
      });
    }

    const res = await fetch(fullUrl.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw { response: { data }, status: res.status };
    return { data };
  },

  post: async (url, body = {}, config = {}) => {
    const res = await fetch(`${BASE_URL}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(config.headers || {}),
      },
      body: JSON.stringify(body),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw { response: { data }, status: res.status };
    return { data };
  },
};

export default API;
